import type { PaymentsListRow } from "@/admin/entities/payments";
import type { PaymentsListQueryType } from "@/types/graphql/admin.generated";

export function getTableData(data: unknown): {
  nodes: PaymentsListRow[];
  count: number;
} {
  const payments = (data as PaymentsListQueryType)?.payments;
  if (!payments || !payments.nodes) {
    return { nodes: [], count: 0 };
  }
  return payments;
}

export function mapColumns(payment: PaymentsListRow) {
  return [
    payment.id,
    // Колонке суммы нужен весь платёж: она ведёт на карточку по id.
    payment,
    payment.amount.valueUSD,
    payment.ottkitFeeAmount?.valueUSD,
    payment.organizationAmount?.valueUSD,
    payment.provider,
    payment,
    payment,
    payment.createdAt,
    payment,
  ];
}
